import React, { useContext, useDebugValue, useEffect, useState } from 'react'
import { getDatabase, ref, get, update, set } from 'firebase/database';
import CustomSelect from '../../Components/CustomSelect';
import GlobalContext from '../../Components/GlobalContext';

import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import ListGroup from 'react-bootstrap/ListGroup'

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'

import MainNav from '../../Components/Navbar'
import { firebaseToString, dateStringToDateTime, dateTimeToDateString } from '../../Tools/tools';
import { compare, distance } from './fuzzy-compare.ts';
import ManutencaoUsuariosModal from './ManutencaoUsuariosModal.js';

function ManutencaoUsuarios() {

    const { globalData } = useContext(GlobalContext);
    const db = getDatabase()

    const [companyNames, setCompanyNames] = useState([]);
    const [allCompanies, setAllCompanies] = useState([]);
    const currentYear = new Date().getFullYear();
    const startYear = 2024;
    const [selectedCompany, setSelectedCompany] = useState('');
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedMonth, setSelectedMonth] = useState(String(new Date().getMonth() + 1).padStart(2, '0'));
    const [selectedYear, setSelectedYear] = useState(String(new Date().getFullYear()));
    const [departmentOptions, setDepartmentOptions] = useState([]);

    const [rawData, setRawData] = useState({});

    const [employeeStats, setEmployeeStats] = useState({})
    const [fuzzyMatches, setFuzzyMatches] = useState([])

    const [employeeList, setEmployeeList] = useState([])
    const [selectedEmployee, setSelectedEmployee] = useState('')

    useEffect(() => {
        const companiesRef = ref(db, '/companies/');
        get(companiesRef).then((snapshot) => {
            if (snapshot.exists()) {
                let companies = []
                for (const [companyName, companyData] of Object.entries(snapshot.val())) {
                    if (companyData.isCompanyVisible) {
                        if (!companies.includes(companyName)) {
                            companies.push(companyName)
                        }
                    }
                }
                companies.sort()
                setCompanyNames(companies)
                setAllCompanies(snapshot.val())
            }
        })
    }, []);

    useEffect(() => {
        if (selectedCompany && selectedDepartment && selectedMonth && selectedYear) {
            const allRolls = rawData[selectedDepartment]

            if (allRolls) {
                let allOriginalTimes = {}

                // Buscando e ordenando todos os registeredDateTimes
                let allRegisteredDateTimes = Object.keys(allRolls)
                allRegisteredDateTimes.sort((a, b) => dateStringToDateTime(a) - dateStringToDateTime(b))

                // Buscando o registeredDateTime mais recente para cada originalTime
                // Criando um dicionario { originalTime: rolData }
                allRegisteredDateTimes.forEach((registeredDateTime) => {
                    const r = dateStringToDateTime(registeredDateTime)

                    if (Object.keys(allRolls[registeredDateTime]).includes("originalTime")) {
                        const originalTime = allRolls[registeredDateTime]["originalTime"]
                        allOriginalTimes[originalTime] = allRolls[registeredDateTime]
                    }
                })

                let employeeStats = {}

                for (const [originalTime, rollData] of Object.entries(allOriginalTimes)) {
                    if (rollData.employees) {
                        const allEmployees = Object.values(rollData.employees)

                        for (const employeeData of Object.values(allEmployees)) {
                            const name = employeeData.employee
                            const status = employeeData.status

                            if (!Object.keys(employeeStats).includes(name)) {
                                employeeStats[name] = {}
                                employeeStats[name]["totalAttendance"] = 1

                                if (status === "PRESENTE") {
                                    employeeStats[name]["totalPresent"] = 1
                                } else {
                                    employeeStats[name]["totalPresent"] = 0
                                }
                            } else {
                                employeeStats[name]["totalAttendance"] += 1

                                if (status === "PRESENTE") {
                                    employeeStats[name]["totalPresent"] += 1
                                }
                            }
                        }
                    }
                }

                let fuzzyMatches = []

                for (const name1 of Object.keys(employeeStats)) {
                    for (const name2 of Object.keys(employeeStats)) {
                        if (name1 === name2) continue;

                        const [jaro, jaccard] = distance(name1, name2)

                        const jaroThreshold = 0.2
                        const jaccardThreshold = 0.2

                        if (jaro >= jaroThreshold, jaccard >= jaccardThreshold) {
                            if ((jaro + jaccard) / 2 >= 0.1) {
                                fuzzyMatches.push({
                                    name1: name1,
                                    name2: name2,
                                    match: (jaro + jaccard) / 2
                                })
                            }
                        }
                    }
                }

                setEmployeeStats(employeeStats)
                setEmployeeList(Object.keys(employeeStats))
                setFuzzyMatches(fuzzyMatches)
            }
        }
    }, [rawData])

    const [showModal, setShowModal] = useState(false)
    const [modalName1, setModalName1] = useState(false)
    const [modalName2, setModalName2] = useState(false)

    const handleMergeNames = (name1, name2) => {
        setShowModal(true)
        setModalName1(name1)
        setModalName2(name2)
    }

    const submitChanges = () => {
        // name1 -> name2
        const oldRollData = { ...rawData[selectedDepartment] }
        let newRollData = {}

        let offset = 1

        for (const [registeredDateTime, rollData] of Object.entries(oldRollData)) {
            if (rollData["employees"]) {
                let employees = rollData["employees"]

                let newEmployees = []

                let newRoll = { ...rollData }

                employees.forEach(({ employee, status }) => {

                    let ne = {
                        'status': 'FALTA'
                    }

                    if (employee === modalName1) {
                        ne['employee'] = modalName2
                        if (status === 'PRESENTE') {
                            ne['status'] = status
                        }
                    } else if (employee !== modalName1 && employee !== modalName2) {
                        ne['employee'] = employee
                        ne['status'] = status
                    }

                    if (ne.employee) {
                        newEmployees.push(ne)
                    }

                    newRoll["employees"] = newEmployees

                })

                let newRegisteredTime = new Date()
                newRegisteredTime.setSeconds(newRegisteredTime.getSeconds() + offset)
                newRegisteredTime = dateTimeToDateString(newRegisteredTime)
                newRoll["registeredDateTime"] = newRegisteredTime
                offset++

                oldRollData[newRegisteredTime] = newRoll
            }
        }

        sendNewRollsToDb(oldRollData)
    }

    const sendNewRollsToDb = async (newRollData) => {
        const path = `/rolls_remodel/${Number(selectedYear)}/${Number(selectedMonth)}/${selectedCompany}/${selectedDepartment}`

        const db = getDatabase()

        set(ref(db, path), newRollData).then(() => {
            setSelectedEmployee('')
            setShowModal(false)
            setRawData({})
        })
    }

    const getCompanyData = async () => {
        if (selectedCompany && selectedDepartment && selectedMonth && selectedYear) {
            const path = `/rolls_remodel/${Number(selectedYear)}/${Number(selectedMonth)}/${selectedCompany}`
            console.log("firebase data - " + path)
            const rollsRef = ref(db, path)
            const snapshot = await get(rollsRef)
            if (snapshot.exists()) {
                setRawData(snapshot.val())
                return snapshot.val()
            } else {
                return null
            }
        }
    }

    const CompanyDataSelect = () => {
        return <div className="my-3 d-flex flex-wrap">
            <CustomSelect
                options={companyNames
                    .filter((name) => name !== 'id')
                    .map((name) => ({ value: name, label: firebaseToString(name) }))}
                value={selectedCompany}
                onChange={(e) => {
                    const companyValue = e.target.value;
                    setSelectedCompany(companyValue);
                    setSelectedDepartment('');
                    const companyData = allCompanies[companyValue];

                    const excludedKeys = ['isCompanyVisible', 'instrutores', 'ordem']

                    if (companyData) {
                        const deps = Object.keys(companyData)
                            .filter((key) => !excludedKeys.includes(key));
                        setDepartmentOptions(
                            deps.map(dep => ({ value: dep, label: firebaseToString(dep) }))
                        );
                    } else {
                        setDepartmentOptions([]);
                    }
                }}
                placeholder="Empresa"
                ariaLabel="select-company"
                className='me-3'
                style={{ width: '300px' }} />

            <CustomSelect
                options={departmentOptions}
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value)}
                placeholder="Departamento"
                ariaLabel="select-department"
                className='me-3'
                style={{ width: '200px' }} />

            <CustomSelect
                options={Array.from({ length: 12 }, (_, i) => {
                    const value = String(i + 1).padStart(2, '0');
                    const label = new Date(0, i).toLocaleString('pt-BR', { month: 'long' });
                    return { value, label: label.charAt(0).toUpperCase() + label.slice(1) };
                })}
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                placeholder="Mês"
                ariaLabel="select-month"
                className="me-3"
                style={{ width: '120px' }} />

            <CustomSelect
                options={Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
                    const year = startYear + i;
                    return { value: String(year), label: String(year) };
                })}
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                placeholder="Ano"
                ariaLabel="select-year"
                className='me-3'
                style={{ width: '80px' }} />

            <Button onClick={() => { getCompanyData() }}>
                Buscar Alunos
            </Button>
        </div>;
    }

    const EmployeeSearch = () => {
        const [employeeFilter, setEmployeeFilter] = useState("")

        let addedItems = []

        return <>
            <Form.Label htmlFor='employeeFilterInput'>
                Pesquisar Aluno
            </Form.Label>
            <Form.Control
                type='text'
                value={employeeFilter}
                onChange={(e) => setEmployeeFilter(e.target.value)}
                id='employeeFilterInput'
                style={{ width: '350px' }}
            />
            <div>
                {employeeFilter.length > 0 && (
                    <ListGroup>
                        {fuzzyMatches
                            .filter(item => {
                                return (item.name1.toLowerCase().includes(employeeFilter.toLowerCase()))
                            })
                            .map((item, idx) => {
                                if (addedItems.includes(item)) return <></>

                                addedItems.push(item)

                                return <ListGroup.Item key={idx} style={{ width: '350px' }} onClick={() => setSelectedEmployee(item.name1)}>
                                    {item.name1}
                                </ListGroup.Item>
                            }
                            )}
                    </ListGroup>
                )}
            </div>
        </>
    }

    const FuzzyMatchingListCol = ({ idx, name }) => {
        const stats = employeeStats[name];

        return (
            <Col key={`col-${idx}`} className="p-2">
                <div className="d-flex align-items-center mb-2">
                    <span
                        className="badge bg-primary me-2"
                        style={{ fontSize: '0.7em' }}
                    >
                        ALUNO {idx}
                    </span>
                    <div
                        className="fw-bold text-dark"
                    >
                        {name}
                    </div>
                </div>

                <div className="mt-3">
                    <div className="d-flex justify-content-between align-items-center mb-2 p-1 bg-light rounded">
                        <span className="text-muted small">Presenças</span>
                        <span className="fw-semibold text-success">{stats.totalPresent}</span>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-2 p-1 bg-light rounded">
                        <span className="text-muted small">Total de aparições</span>
                        <span className="fw-semibold">{stats.totalAttendance}</span>
                    </div>
                </div>
            </Col>
        );
    };

    const FuzzyMatchingList = () => {
        return (
            <Container className='mt-2'>
                <h6>Possíveis Duplicatas</h6>
                {Object.values(fuzzyMatches).map((val, index) => {
                    const matchPercentage = (val.match * 100).toFixed(0);
                    const matchColor = matchPercentage >= 90 ? 'success' :
                        matchPercentage >= 70 ? 'warning' : 'danger';

                    if (selectedEmployee != val.name1 && selectedEmployee != val.name2) {
                        return <></>
                    }

                    return (
                        <Card
                            key={index}
                            className="mb-4 shadow-sm"
                            style={{ maxWidth: "50rem" }}
                        >
                            <Card.Body className="pt-3">
                                <Row className="g-4">
                                    <FuzzyMatchingListCol idx={1} name={val.name1} />
                                    <div className="col-auto d-flex align-items-center">
                                        <i
                                            className="bi bi-arrow-right-square-fill"
                                            style={{ fontWeight: "2000", color: "green", fontSize: "1.5em" }}
                                        ></i>
                                    </div>
                                    <FuzzyMatchingListCol idx={2} name={val.name2} />
                                </Row>
                                <div className="pt-3 border-top">
                                    <div className="d-flex justify-content-end gap-3">
                                        <div className="d-flex align-items-center">
                                            <span className="me-2 small text-muted">Semelhança:</span>
                                            <span
                                                className={`badge bg-${matchColor} fs-6`}
                                                style={{ minWidth: '60px' }}
                                            >
                                                {matchPercentage}%
                                            </span>
                                        </div>
                                        <button
                                            className="btn btn-success btn-sm"
                                            onClick={() => handleMergeNames(val.name1, val.name2)}
                                        >
                                            <i className="bi bi-check-circle me-2"></i>
                                            Unificar Nomes
                                        </button>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    );
                })}
            </Container>
        );
    };

    return (
        <>
            <MainNav />
            <Container>
                <CompanyDataSelect />

                {Object.keys(rawData).length > 0 && <EmployeeSearch />}

                <ManutencaoUsuariosModal
                    show={showModal}
                    setShow={setShowModal}
                    name1={modalName1}
                    name2={modalName2}
                    submit={submitChanges}
                />

                {selectedEmployee && <FuzzyMatchingList />}
            </Container>
        </>
    )
}

export default ManutencaoUsuarios